import { tns } from "tiny-slider"
document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.events__list');

    for (const slider of sliders) {
        const hasExcerpt = !!slider.closest('.events')?.querySelector('.events__column--excerpt');
        const defaultItems = parseInt(slider.dataset.baseCount) || 3;
        tns({
            center: false,
            container: slider,
            slideBy: 1,
            autoplay: false,
            controls: true,
            nav: false,
            speed: 250,
            mouseDrag: true,
            gutter: 16,
            controlsText: ['', ''],
            items: 1.2,
            loop: false,
            onInit: function (instance) {
                instance.nextButton.ariaLabel = "Framåt";
                instance.prevButton.ariaLabel = "Bakåt";

                console.log(instance)
            },
            afterInit: function (instance) {

                console.log(instance)
                const $tnsOuterDiv = document.querySelector('.events .tns-outer');
                $tnsOuterDiv.style.height = '100%';

                $tnsOuterDiv.style.overflow = 'hidden';

            },
            controlsContainer: slider.closest(".events").querySelector('.events__controls'),
            responsive: {
                768: {
                    items: hasExcerpt ? 1 : 2,
                    gutter: 16,
                    autoWidth: true,
                },
                992: {
                    items: hasExcerpt ? 2 : defaultItems,
                    gutter: 16,
                    autoWidth: true,
                },
                1200: {
                    items: 3,
                    gutter: 16,
                    autoWidth: true,
                }
            }
        });
    }
});
